import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import DatePicker from "react-datepicker2";
import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { resetChequeFilters, searchForCheque } from "../store/api/DocumentsAPI";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, Search } from "react-bootstrap-icons";
import { chequeStatusArray, exportToExcel } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch, useSelector } from "react-redux";
import ModalAddEditChequeFunctions from "../Components/ModalAddEditChequeFunctions";

const SearchCheques = () => {
    const dispatch = useDispatch();
    const frmFilters = useRef();
    const dateFilters = useRef({});
    const [pending, setPending] = useState(false);
    const { register, handleSubmit } = useForm();
    const [groupByCheq, setGroupByCheq] = useState(true);
    const [statusArray, setStatusArray] = useState([...chequeStatusArray]);
    const [showFilter, setShowFilter] = useState(true);
    const filterData = useSelector(state => state.DocumentReducer.cheqSearchFilters);
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });
    function clearFilters() {
        frmFilters.current.reset();
        dateFilters.current = {};
        dispatch(resetChequeFilters({ Take: 10, Skip: 0 }));
        dispatch(searchForCheque({ Take: 10, Skip: 0 }));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        data.Skip = 0;
        if (Array.isArray(data.GroupByCheque)) {
            data.GroupByCheque = data.GroupByCheque.some(c => c === "on");
        }
        const dueDateFrom = document.getElementsByName("DueDateFrom")[0];
        if (dueDateFrom.value !== "") {
            data.DueDateFrom = dateFilters.current.DueDateFrom;
        }
        else {
            dateFilters.current.DueDateFrom = null;
        }
        const dueDateTo = document.getElementsByName("DueDateTo")[0];
        if (dueDateTo.value !== "") {
            data.DueDateTo = dateFilters.current.DueDateTo;
        }
        else {
            dateFilters.current.DueDateTo = null;
        }
        dispatch(searchForCheque(data));
    }
    function onCheqTypeChanged(e) {
        if (e.target.value === "true") {
            const newArray = chequeStatusArray.filter(s => s.StatusName.includes("in"));
            setStatusArray(newArray);
        }
        else if (e.target.value === "false") {
            const newArray = chequeStatusArray.filter(s => s.StatusName.includes("out"));
            setStatusArray(newArray);
        }
        else if (e.target.value === "") {
            setStatusArray([...chequeStatusArray]);
        }
    }
    function rowClick(row) {
        if(row.ChequeStatus === "White")
        {
            return;
        }
        if (Number(row.FunctionID) > 0 || ((row.ChequeStatus ?? "") !== "" && (Number(row.ChequeID) > 0))) {

            if (row.e) {
                delete row.e;
            }
            setModalCheqFunctions({
                Show: true,
                FunctionID: row.FunctionID,
                ChequeStatus: row.ChequeStatus,
                ChequeID: row.ChequeID
            })
        }
    }
    function toExcel() {
        const url = "api/DocumentsAPI/SearchForCheque";
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("ChequesReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "شماره چک", colName: "ChequeNumber", justInMobile: true },
        { colTitle: "نام بانک و شعبه", colName: "BankName", justInMobile: true },
        { colTitle: "شماره حساب", colName: "BankAccountNo" },
        { colTitle: "مبلغ چک", colName: "ChequeAmount", colType: "currency" },
        { colTitle: "پشت نمره", colName: "ChequeBackNo" },
        { colTitle: "چک دریافتنی", colName: "IsInput", colType: "boolean" },
        { colTitle: "طرف حساب چک", colName: "LastAccountName", showCondition: () => !groupByCheq },
        { colTitle: (groupByCheq?"آخرین ":"")+ "وضعیت چک", colName: "PChequeStatus" },
        { colTitle: "تاریخ ثبت وضعیت", colName: "PCreationDate", showCondition: () => !groupByCheq },
        { colTitle: "تاریخ سررسید", colName: "PDueDate" }
    ]
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-3">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;
                    جستجوی چک
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نوع چک: </label>
                                <select className="form-control" name="IsInput" ref={register({})} onChange={onCheqTypeChanged}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={true}>چک های دریافتنی</option>
                                    <option value={false}>چک های پرداختنی</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت چک: </label>
                                <select className="form-control" name="ChequeStatus" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(statusArray) && statusArray.map((sa, i) => <option value={sa.StatusName} key={i}>{sa.StatusTitle}</option>)}
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره چک: </label>
                                <Form.Control name="ChequeNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره حساب</label>
                                <Form.Control name="BankAccountNo" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>بانک صادر کننده: </label>
                                <Form.Control name="BankName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام طرف حساب: </label>
                                <Form.Control name="AccountName" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مبلغ چک: </label>
                                <Form.Control type="number" name="ChequeAmount" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سررسید از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DueDateFrom"
                                    value={filterData?.DueDateFrom ? momentJalaali(filterData.DueDateFrom.substring(0, 10)) : dateFilters.current.DueDateFrom ? momentJalaali(dateFilters.current.DueDateFrom) : null}
                                    onChange={val => dateFilters.current.DueDateFrom = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group" >
                                <label>سررسید تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="DueDateTo"
                                    value={filterData?.DueDateTo ? momentJalaali(filterData.DueDateTo.substring(0, 10)) : dateFilters.current.DueDateTo ? momentJalaali(dateFilters.current.DueDateTo) : null}
                                    onChange={val => dateFilters.current.DueDateTo = val.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه: </label>
                                <select className="form-control" defaultValue={10} ref={register({})} name="Take">
                                    <option value={0}>انتخاب کنید</option>
                                    <option value={10}>10 ردیف</option>
                                    <option value={20}>20 ردیف</option>
                                    <option value={50}>50 ردیف</option>
                                    <option value={100}>100 ردیف</option>
                                </select>
                            </Col>
                            <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "3px" }}>
                                <div className="rowBorder" style={{ padding: "5px" }}>
                                    <input className="form-check-input" type="checkbox" ref={register({})} name="GroupByCheque" onChange={e => setGroupByCheq(e.target.checked)} defaultChecked={true} /> &nbsp;
                                    <label style={{ color: "blue" }}>نمایش به تفکیک چک</label>
                                </div>
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit"><Search size={18} />&nbsp; جستجوی چک</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} objectName="cheqSearchList" reducerName="DocumentReducer" filterData={filterData} className="mt-1"
                    searchMethod={(data) => dispatch(searchForCheque(data))} hasPaging={true} style={{ whiteSpace: "nowrap" }} rowClick={rowClick} />
                </Card.Body>
            </Card>
        </div>)
}
export default SearchCheques;